import { Link } from '@tanstack/react-router';
import { ShieldAlert } from 'lucide-react';
import { Card } from '@pixlide/ui';

/** Page 403 générique — aussi utilisée comme `notFoundComponent` du routeur. */
export function ForbiddenPage({ title, description }: { title: string; description: string }) {
  return (
    <div className="flex min-h-dvh items-center justify-center px-4">
      <Card className="flex max-w-md flex-col items-center gap-3 px-8 py-10 text-center">
        <ShieldAlert aria-hidden className="size-10 text-danger-500" strokeWidth={1.25} />
        <h1 className="text-xl font-semibold">{title}</h1>
        <p className="text-sm text-ink-500">{description}</p>
        <Link to="/connexion" className="mt-2 text-sm font-semibold text-ink-900 hover:underline">
          Retour à la connexion
        </Link>
      </Card>
    </div>
  );
}
